import React, { Component } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { UncontrolledTooltip } from "reactstrap";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

class DraggableGrid extends Component {
  onDragEnd = (result) => {
    if (!result.destination) return;

    const { data } = this.props;
    const newData = reorder(
      data,
      result.source.index,
      result.destination.index
    );

    this.props.onOrderChange(newData.map(item => item._id));
  };

  getColumnWidth = (column) => {
    const { columnWidths } = this.props;
    return columnWidths && columnWidths[column.key]
      ? columnWidths[column.key]
      : '1fr'; // Default to equal width distribution
  }

  renderItem = (item, index) => {
    const {
      checked,
      checkRow,
      onClick,
      columns,
      disableCheck,
      readOnly
    } = this.props;

    return (
      <Draggable
        key={item._id}
        draggableId={item._id}
        index={index}
      >
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            className={`draggableGridItem ${checked[item._id] ? "checked" : ""}`}
            style={{
              backgroundColor: snapshot.isDragging ? "#f5f5f5" : undefined,
              ...provided.draggableProps.style
            }}
          >
            <div className="gridItemContent">
              {/* Drag Handle */}
              <div {...provided.dragHandleProps} className="dragHandle">
                <i className="las la-braille" />
              </div>

              {/* Checkbox */}
              {!readOnly && !disableCheck && (
                <div
                  className={`checkBox ${checked[item._id] ? "checked" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    checkRow(item._id);
                  }}
                >
                  <i className="las la-check" />
                </div>
              )}

              {/* Content */}
              <div
                className="itemDetails"
                onClick={() => onClick && onClick(item._id)}
                style={{
                  display: 'grid',
                  gridTemplateColumns: columns.map(col => this.getColumnWidth(col)).join(' ')
                }}
              >
                {columns.map((column, colIndex) => {
                  const value = item[column.key];
                  const displayValue = typeof value === 'boolean'
                    ? (value ? 'Yes' : 'No')
                    : value;

                  return (
                    <div key={column.key} className="columnValue">
                      <div className="columnLabel">{column.label}</div>
                      <div
                        className="columnContent"
                        id={`tooltip-${item._id}-${column.key}`}
                      >
                        {column.type === 'icon' ? (
                          <i className={`${displayValue}`} />
                        ) : (
                          <span>{displayValue}</span>
                        )}
                      </div>
                      {displayValue && displayValue.length > 30 ? (
                        <UncontrolledTooltip
                          placement="top"
                          target={`tooltip-${item._id}-${column.key}`}
                        >
                          {displayValue}
                        </UncontrolledTooltip>
                      ) : ''}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </Draggable>
    );
  };

  render() {
    const { data, title } = this.props;

    return (
      <div className="draggableGridContainer">
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className="gridItems"
              >
                {data.map((item, index) => this.renderItem(item, index))}
                {provided.placeholder}

                {data.length === 0 && (
                  <div className="emptyMessage">
                    <h2>No {title} Yet</h2>
                    <p>Add {title} to view and manage.</p>
                  </div>
                )}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    );
  }
}

DraggableGrid.defaultProps = {
  data: [],
  columns: [],
  checked: {},
  onOrderChange: () => { },
  disableCheck: false,
  readOnly: false,
  columnWidths: null // Example: { description: '2fr', pointValue: '100px' }
};

export default DraggableGrid;
